import styled from '@emotion/styled/macro';
import { Variables } from '../base';

export const Wrapper = styled.section`
    padding: 25px 56px;
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    overflow: hidden;
`;

export const PageHeader = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 24px;
    flex-wrap: wrap;
    flex: none;
`;

export const PageHeaderMain = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const PageSubtitle = styled.div`
    font-size: 13px;
    color: ${Variables.Colors.n70};
`;

export const Title = styled.h1`
    margin: 0;
    height: 28px;
    font-family: Calibre;
    font-size: 28px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0.2px;
    color: ${Variables.Colors.p500};
`;

export const Meta = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    font-size: 14px;
    color: ${Variables.Colors.n70};
`;

export const HeaderActions = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const UnsavedLabel = styled.span`
    font-size: 12px;
    font-weight: 500;
    color: ${Variables.Colors.warning};
`;

export const ActionButton = styled.button`
    padding: 8px 14px;
    border: 1px solid ${Variables.Colors.n15_48};
    border-radius: 6px;
    background: ${Variables.Colors.white};
    color: ${Variables.Colors.n70};
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;

    &:hover:not(:disabled) {
        background: ${Variables.Colors.n15_24};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }
`;

export const PrimaryButton = styled(ActionButton)`
    border: none;
    background: ${Variables.ThemeLight.PrimaryConstant6};
    color: ${Variables.Colors.white};

    &:hover:not(:disabled) {
        background: ${Variables.ThemeLight.PrimaryConstant1};
    }
`;

export const SaveError = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.warning};
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-height: 200px;
    background: transparent;
`;

export const ErrorContainer = styled.div`
    color: ${Variables.Colors.warning};
    padding: 16px;
`;

export const Content = styled.div`
    display: flex;
    gap: 20px;
    align-items: stretch;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`;

export const ReadOnlyDetailShell = styled.div`
    flex: 1;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;

    &[data-readonly='true'] {
        input,
        select,
        textarea,
        button {
            pointer-events: none;
            cursor: not-allowed;
        }

        button[data-allow-interaction='true'] {
            pointer-events: auto;
            cursor: pointer;
        }
    }
`;

export const CatalogBanner = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    border: 1px solid ${Variables.Colors.n15_48};
    background: ${Variables.Colors.white};
    color: ${Variables.Colors.n70};
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
`;
